import { Pipe, PipeTransform } from '@angular/core'
import { get, merge, orderBy } from 'lodash';

@Pipe({ name: 'sortBy'})
export class SortByPipe<T> implements PipeTransform {
  transform(original: T[], options = {}): T {
    const opts = merge({
      sortBy: '',
      reverse: false
    }, options)

    return this.sortObjects(original, opts['sortBy'], opts['reverse']);
  }

  private sortObjects(objects: any[], sortBy = '', reverse = false): any {
    if (!objects || sortBy === '') {
      return objects
    }
    return orderBy(objects, [(a) => get(a, sortBy) || -1], [reverse ? 'desc' : 'asc']);
  }
}
